import React, { useRef, useState } from 'react';
import { FiHash, FiLogIn, FiLock, FiUser, FiArrowRight } from 'react-icons/fi';
import {
  FaInstagram,
  FaPizzaSlice,
  FaHamburger,
  FaCoffee,
  FaIceCream,
  FaCookieBite,
  FaBreadSlice,
  FaCarrot,
  FaDrumstickBite,
} from 'react-icons/fa';
import { gsap } from 'gsap';
import { useGSAP } from '@gsap/react';
import {
  NotificationManager,
  NotificationContainer,
} from 'react-notifications';
import { Redirect } from 'react-router-dom';
import { useAuth } from '../../hooks/auth';
import { schemalogin } from './schema/login.schema';
import logoIntro from '../../assets/icon_branco.png';
import logoGestor from '../../assets/logo_gestor_sem_fundo.png';
import {
  PageWrapper,
  PageAura,
  AuraBlob,
  IntroOverlay,
  IntroLogo,
  Card,
  LeftPanel,
  DecorLayer,
  PanelGlow,
  OrbitLayer,
  IconOrb,
  IconOrbInner,
  MobileIconRow,
  MobileIconChip,
  BrandBlock,
  BadgePill,
  FormLogo,
  BrandName,
  Greeting,
  Tagline,
  RightPanel,
  DecorLayerLight,
  LightBlob,
  PastelBubble,
  FormContent,
  FormSubtitle,
  Avatar,
  InputGroup,
  IconChip,
  InputWrap,
  LoginButton,
  FooterLinks,
} from './styles';

gsap.registerPlugin(useGSAP);

const TERMS_URL = 'https://www.unitechsistemas.com.br/terms';
const INSTAGRAM_URL = 'https://www.instagram.com/unitech_oficial/';

const FOOD_ICONS = [
  { Icon: FaPizzaSlice, top: '8%', left: '14%', size: 84, rotate: -18 },
  { Icon: FaIceCream, top: '12%', left: '80%', size: 64, rotate: 14 },
  { Icon: FaHamburger, top: '40%', left: '90%', size: 92, rotate: 12 },
  { Icon: FaCoffee, top: '90%', left: '84%', size: 76, rotate: -10 },
  { Icon: FaCookieBite, top: '88%', left: '16%', size: 70, rotate: 20 },
  { Icon: FaDrumstickBite, top: '60%', left: '6%', size: 88, rotate: -24 },
  { Icon: FaCarrot, top: '34%', left: '4%', size: 54, rotate: 30 },
  { Icon: FaBreadSlice, top: '70%', left: '60%', size: 58, rotate: -14 },
];

const ELEMENTOS_INICIAIS = [
  '.pastel-bubble',
  '.panel-glow',
  '.icon-orb',
  '.badge-pill',
  '.brand-logo',
  '.brand-name',
  '.tagline',
  '.mobile-icon-row',
  '.avatar',
  '.form-title',
  '.form-subtitle',
  '.input-group',
  '.login-button',
  '.footer-links',
];

export default function LoginGestor() {
  const { signIn, isAuth, bloqueio } = useAuth();
  const [login, setLogin] = useState('');
  const [senha, setSenha] = useState('');
  const [idEmpresa, setIdEmpresa] = useState('');
  const [introVisible, setIntroVisible] = useState(true);

  const pageRef = useRef(null);
  const buttonRef = useRef(null);

  const { contextSafe } = useGSAP(
    () => {
      const mm = gsap.matchMedia();

      mm.add('(prefers-reduced-motion: reduce)', () => {
        setIntroVisible(false);
        gsap.set(ELEMENTOS_INICIAIS, { opacity: 1, scale: 1, x: 0, y: 0 });
        gsap.set('.card', { opacity: 1, scale: 1, x: 0, y: 0 });
      });

      mm.add('(prefers-reduced-motion: no-preference)', () => {
        gsap.set(ELEMENTOS_INICIAIS, { opacity: 1 });

        const tl = gsap.timeline({
          delay: 0.05,
          onComplete: () => setIntroVisible(false),
        });

        tl.fromTo(
          '.intro-logo',
          { opacity: 0 },
          { opacity: 1, duration: 0.3, ease: 'power2.out' },
          0,
        )
          .to('.intro-logo', { scale: 2.4, duration: 1.2, ease: 'power2.in' }, 0)
          .addLabel('outro', 0.6)
          .set('.intro-overlay', { pointerEvents: 'none' }, 'outro')
          .to('.intro-logo', { opacity: 0, duration: 0.5, ease: 'power2.in' }, 'outro')
          .to('.intro-overlay', { opacity: 0, duration: 0.6, ease: 'power2.inOut' }, 'outro+=0.2')
          .fromTo(
            '.card',
            { opacity: 0, scale: 0.96, y: 12 },
            { opacity: 1, scale: 1, y: 0, duration: 0.55, ease: 'expo.out' },
            'outro+=0.05',
          );
      });

      return () => mm.revert();
    },
    { scope: pageRef },
  );

  const handleButtonEnter = contextSafe(() => {
    gsap.to(buttonRef.current, { scale: 1.03, duration: 0.25, ease: 'power2.out' });
  });
  const handleButtonLeave = contextSafe(() => {
    gsap.to(buttonRef.current, { scale: 1, duration: 0.3, ease: 'power2.out' });
  });
  const handleButtonDown = contextSafe(() => {
    gsap.to(buttonRef.current, { scale: 0.96, duration: 0.12, ease: 'power2.out' });
  });
  const handleButtonUp = contextSafe(() => {
    gsap.to(buttonRef.current, { scale: 1.03, duration: 0.18, ease: 'power2.out' });
  });

  const entrar = async (e) => {
    e.preventDefault();
    schemalogin.validate({
      IdEmpresa: +idEmpresa,
      Login: login,
      Senha: senha
    }).then(async() => {
      try {
        await signIn(idEmpresa, login, senha);
      } catch (err) {
        NotificationManager.error(
          'Usuário ou senha inválidos: ' + err.response?.data?.message,
          'Erro',
        );
      }
    }).catch((error) =>{
      NotificationManager.error(error.message, 'Aviso');
    })
    if (login && senha && idEmpresa) {
    } else {
      NotificationManager.error('Preencha todos os campos', 'Erro', 4000);
    }
  };

  if (isAuth) {
    return (
      <Redirect
        to={{
          pathname: bloqueio ? '/bloqueado' : '/g_pedidos',
        }}
      />
    );
  }

  document.title = 'MenuCheff Gestor';

  return (
    <PageWrapper ref={pageRef}>
      <PageAura>
        <AuraBlob
          className="aura-blob"
          style={{ width: 420, height: 420, top: '-12%', left: '-8%', background: 'radial-gradient(circle, rgba(47, 111, 237, 0.28) 0%, rgba(47, 111, 237, 0) 70%)' }}
        />
        <AuraBlob
          className="aura-blob"
          style={{ width: 380, height: 380, bottom: '-16%', right: '-6%', background: 'radial-gradient(circle, rgba(143, 95, 240, 0.26) 0%, rgba(143, 95, 240, 0) 70%)' }}
        />
        <AuraBlob
          className="aura-blob"
          style={{ width: 260, height: 260, top: '40%', right: '18%', background: 'radial-gradient(circle, rgba(255, 150, 90, 0.16) 0%, rgba(255, 150, 90, 0) 70%)' }}
        />
      </PageAura>

      {introVisible && (
        <IntroOverlay className="intro-overlay">
          <IntroLogo className="intro-logo" src={logoIntro} alt="" />
        </IntroOverlay>
      )}

      <Card className="card">
        <LeftPanel>
          <DecorLayer>
            <PanelGlow className="panel-glow" />

            <OrbitLayer className="orbit-layer">
              {FOOD_ICONS.map(({ Icon, top, left, size, rotate }) => (
                <IconOrb key={top + left} className="icon-orb" style={{ top, left }}>
                  <IconOrbInner style={{ transform: `rotate(${rotate}deg)` }}>
                    <Icon size={size} />
                  </IconOrbInner>
                </IconOrb>
              ))}
            </OrbitLayer>
          </DecorLayer>

          <BrandBlock>
            <BadgePill className="badge-pill">Painel do Gestor</BadgePill>
            <FormLogo className="brand-logo" src={logoGestor} alt="MenuCheff Gestor" />
            <Tagline className="tagline">
              Gerencie pedidos, cardápio e equipe em um só lugar.
            </Tagline>
            <MobileIconRow className="mobile-icon-row">
              {FOOD_ICONS.slice(0, 5).map(({ Icon, top, left }) => (
                <MobileIconChip key={`m-${top}-${left}`}>
                  <Icon size={15} />
                </MobileIconChip>
              ))}
            </MobileIconRow>
          </BrandBlock>
        </LeftPanel>

        <RightPanel>
          <DecorLayerLight>
            <LightBlob
              className="light-blob"
              style={{ width: 260, height: 260, top: -80, right: -60, background: 'radial-gradient(circle, rgba(47, 111, 237, 0.16) 0%, rgba(47, 111, 237, 0) 70%)' }}
            />
            <LightBlob
              className="light-blob"
              style={{ width: 220, height: 220, bottom: -70, left: -50, background: 'radial-gradient(circle, rgba(143, 95, 240, 0.14) 0%, rgba(143, 95, 240, 0) 70%)' }}
            />

            <PastelBubble className="pastel-bubble" style={{ width: 70, height: 70, top: 28, right: 34 }} />
            <PastelBubble className="pastel-bubble" style={{ width: 40, height: 40, top: 96, right: 96 }} />
            <PastelBubble className="pastel-bubble" style={{ width: 54, height: 54, bottom: 40, left: 30 }} />
          </DecorLayerLight>

          <FormContent className="form-content">
            <Avatar className="avatar">
              <FiUser size={36} />
            </Avatar>

            <form onSubmit={entrar}>
              <h1 className="form-title">Bem-vindo de volta</h1>
              <FormSubtitle className="form-subtitle">
                Acesse sua conta para continuar
              </FormSubtitle>

              <InputGroup className="input-group">
                <IconChip>
                  <FiHash size={16} />
                </IconChip>
                <InputWrap>
                  <input
                    type="number"
                    name="empresa"
                    placeholder="Empresa"
                    defaultValue={idEmpresa}
                    onChange={(e) => setIdEmpresa(e.target.value)}
                  />
                </InputWrap>
              </InputGroup>

              <InputGroup className="input-group">
                <IconChip>
                  <FiLogIn size={16} />
                </IconChip>
                <InputWrap>
                  <input
                    type="text"
                    name="login"
                    placeholder="Login"
                    defaultValue={login}
                    onChange={(e) => setLogin(e.target.value)}
                  />
                </InputWrap>
              </InputGroup>

              <InputGroup className="input-group">
                <IconChip>
                  <FiLock size={16} />
                </IconChip>
                <InputWrap>
                  <input
                    type="password"
                    name="senha"
                    placeholder="Senha"
                    defaultValue={senha}
                    onChange={(e) => setSenha(e.target.value)}
                  />
                </InputWrap>
              </InputGroup>

              <LoginButton
                className="login-button"
                type="submit"
                ref={buttonRef}
                onMouseEnter={handleButtonEnter}
                onMouseLeave={handleButtonLeave}
                onMouseDown={handleButtonDown}
                onMouseUp={handleButtonUp}
              >
                Entrar
                <FiArrowRight size={17} />
              </LoginButton>
            </form>

            <FooterLinks className="footer-links">
              <a
                className="instagram-link"
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
              >
                <FaInstagram size={16} />
              </a>
              <a href={TERMS_URL} target="_blank" rel="noreferrer">
                Termos de uso
              </a>
            </FooterLinks>
          </FormContent>
        </RightPanel>
      </Card>

      <NotificationContainer />
    </PageWrapper>
  );
}
